import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { convertCamelToNormalCase } from "../../Dashboard2.1/components/utils";
import DateFnsUtils from "@date-io/date-fns";
import Highcharts from "highcharts/highstock";
import variwide from "highcharts/modules/variwide";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import { Grid, Box, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import IconButton from "@material-ui/core/IconButton";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import LoaderView from "../../../components/LoaderView";

import { dateConfig, timeConfig } from "pages/Punch/config";
import { getWorkerPunchRecords, getWeekNumber } from "services";
variwide(Highcharts);
//variwide(ReactHighcharts);
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    minHeight: 120,
    padding: 0,
  },
  mainCard: {
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  cardHeader: {
    paddingLeft: theme.spacing(2.125),
    paddingRight: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  cardTitle: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  boxContent: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  timeSet: {
    paddingTop: 5,
    marginBottom: 5,
    fontWeight: "bold",
    textAlign: "right",
  },
  timeIn: {
    color: "#8DC13F",
    paddingRight: 15,
  },
  timeOut: {
    color: "#58595B",
    paddingRight: 15,
  },
  chartDiv: {
    width: "100%",
    overflow: "auto",
    whiteSpace: "nowrap",
    paddingRight: 15,
  },
}));

const formatXAxis = (tickItem) => {
  return moment(tickItem).format(timeConfig.format2);
};

export const WareHouseTimeLineView = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [utcOffset, setUtcOffset] = useState("");
  const [lastColor, setLastColor]= useState(null);
  const startDate = new Date();
  const endDate = new Date(2019, 9, 15);
  const {
    onClickMenu,
    title,
    children,
    empTimeLineData,
    employeeTimeLineViewLoading,
    timeLineViewData,
    selectedDate,
    inTimes,
    outTimes,
    workerName,
  } = props;
  //const Charts = ReactHighcharts.withHighcharts(Highstock);
  let inTS = useState("");
  let outTS = useState("");
  if (inTimes === "") {
    inTS = "";
  } else {
    inTS = moment(inTimes).format("DD/MM HH:mm ");
  }
  if (outTimes === "") {
    outTS = "";
  } else {
    outTS = moment(outTimes).format("DD/MM HH:mm ");
  }

  // const startTimeMilli = moment(selectedDate).startOf('day').valueOf();
  // const nextStartTimeMilli= moment(selectedDate).endOf('day').valueOf();
  useEffect(() => {
    let result = [];
    let isUtcOffsetSet = false;
    if (empTimeLineData.length > 0) {
      empTimeLineData.forEach((record) => {
        let startTimeMap = {};
        let endTimeMap = {};
        let endTimeCloseMap = {};
        let chartColor =null;
        //let timeDiff = 0 ;
        const timeDiff = timeDifference(record.activityStartDateTime,record.activityEndDateTime);
        const startDateTime = moment(record.activityStartDateTime).valueOf();
        const endDateTime = moment(record.activityEndDateTime).valueOf();
        if (!isUtcOffsetSet) {
          let offsetString = record.activityStartDateTime
            .slice(-6)
            .replace(":", "");
          setUtcOffset(offsetString);
          isUtcOffsetSet = true;
        }
        const assetCount = Number(record.assetCount);
        const duration = record.duration;
        
        const activityNameKey =  record.activityNameKey;
        // record.activityNameKey;
        let actNameType = "";
       // chartColor =  getRandColor(false,5)
        //Check condition activity is either "OUTBOUND RETRIEVAL" or "CONFIRM & STAGE".,
        if (
          activityNameKey === "outboundRetrieval" ||
          activityNameKey === "confirmAndStage"
        ) {
          typeof record.orderType === "undefined"
            ? (actNameType = convertCamelToNormalCase(record.activityNameKey))
            : (actNameType = convertCamelToNormalCase(record.orderType));
        } else {
          actNameType = convertCamelToNormalCase(record.activityNameKey);
        }
        const actName = actNameType;
        const translatedKey = (activityNameKey === "outboundRetrieval" || activityNameKey === "confirmAndStage")
                                 && record.orderType !== "undefined"? record.orderType: record.activityNameKey;
        const totalAssetScanCount = Number(record.totalAssetScanCount);
        // for pointing activtiy Start time on x axis
        startTimeMap.x = startDateTime;
        startTimeMap.y = 0;
        startTimeMap.z = endDateTime-startDateTime;
        startTimeMap.actName = actName;
        startTimeMap.totalAssetScanCount = totalAssetScanCount;
        startTimeMap.duration = 0;
        startTimeMap.timeDiff =timeDiff;
        startTimeMap.translatedKey = translatedKey;
        // for pointing activtiy End time on x axis
        endTimeMap.x = startDateTime;
        endTimeMap.y = assetCount;
        endTimeMap.z = endDateTime-startDateTime;
        endTimeMap.actName = actName;
        endTimeMap.totalAssetScanCount = totalAssetScanCount;
        endTimeMap.duration = duration;
        endTimeMap.translatedKey = translatedKey;
       // endTimeMap.color = chartColor;
        endTimeMap.timeDiff =timeDiff;
        endTimeCloseMap.x = endDateTime;
        endTimeCloseMap.y = 0;
        endTimeCloseMap.z = 0;
        endTimeCloseMap.actName = actName;
        endTimeCloseMap.totalAssetScanCount = totalAssetScanCount;
        endTimeCloseMap.duration = 0;
        endTimeCloseMap.timeDiff =timeDiff;
        endTimeCloseMap.translatedKey = translatedKey;
        let timeDetailMap = { startTimeMap, endTimeMap };
        result.push(startTimeMap, endTimeMap, endTimeCloseMap);
      });
    }
    console.log("chartData",result);
    setData(result);
  }, [empTimeLineData]);

   function timeDifference(activityStartDateTime, activityEndDateTime, ){
    let minDiff = parseInt(
      moment
        .duration(moment(activityEndDateTime).diff(moment(activityStartDateTime)))
        .asMinutes()
    );
    let hours = Math.floor( minDiff / 60);
    let minutes = minDiff % 60;
    let timeDiff = hours +":"+ minutes + " hours";
    return timeDiff;
   }
  function getRandColor(same, darkness) {
    //6 levels of brightness from 0 to 5, 0 being the darkest
    var rgb = [];
    if(same && lastColor) {
        rgb = lastColor;
    } else {
        rgb = [Math.random() * 256, Math.random() * 256, Math.random() * 256];
    }
    var mix = [darkness * 51, darkness * 51, darkness * 51]; //51 => 255/5
    var mixedrgb = [rgb[0] + mix[0], rgb[1] + mix[1], rgb[2] + mix[2]].map(function (x) {
        return Math.round(x / 2.0)
    })
    setLastColor(rgb);
    return "rgb(" + mixedrgb.join(",") + ")";
}

  const config = {
    chart: {
      type: "variwide",
      style: {
        fontFamily: "Arial",
      },
    },
    title: {
      text: "",
    },
    time: {
      useUTC: false,
    },
    global: {
      useUTC: false,
    },
    scrollbar: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    yAxis: {
      // min: 0,
      // max: 100,
      lineWidth: 2,
      gridLineWidth: 0,
      title: {
        text:t("other.lblAssetCount")
      },
      // tickPositioner: function (i) {
      //   var info = this.tickPositions.info;
      //   var positions = [];
      //   for (i = 0; i <= 100; i += 10) {
      //     positions.push(i);
      //   }
      //   positions.info = info;
      //   return positions;
      // },
    },
    xAxis: {
      // min: startTimeMilli,
      // max: nextStartTimeMilli,
      gridLineWidth: 0,
      type: "datetime",
      title: {
        text: t("other.lblTime"),
      },
      dateTimeLabelFormats: {
        day: "%H:%M",
      },
     tickInterval: 10,
     labels: {
        overflow: "justify",
        formatter: function () {
          return moment(this.value)
            .utcOffset(utcOffset)
            .format(timeConfig.format3);
        },
      },
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        const assetCount = this.y;
        const duration = this.point.options.duration;
        const actName = t(`other.${this.point.options.translatedKey}`);
        const timeDiffShow = this.point.options.timeDiff;
        let totalAssetScanCount = this.point.options.totalAssetScanCount;
        let aph = 0;
        if (Number(duration) > 0) aph = assetCount / duration;
        const time = moment(this.x)
          .utcOffset(utcOffset)
          .format(timeConfig.format3);
        aph = parseFloat(aph.toFixed(2));
        return (
          '<div style="direction:rtl; opacity: 3;" class="tooltip">' +
          "<p>" +
          actName +
          "</p><p>" +
           aph +
          " :APH" +
          "</p><p>" +
          duration +
          " :Duration"+
          "</p><p>" +
          assetCount +
          " :Asset Count" +
          "</p>" +
          "</div>"
        );
       
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      variwide: {
              stacking: 'normal',},
      series: {
        pointWidth: 30,
      },
    },

    series: [
      {
       showInLegend: false,
       findNearestPointBy: "xy",
       type: 'variwide',
        data: data,
        dataLabels: {
          enabled: true,
          inside: false,
          formatter: function () {
            const assetCount = this.y;
            const actName = t(`other.${this.point.options.translatedKey}`);
            const timeDiffShow = this.point.options.timeDiff;
           return (
              '<div>' +
              "<p>" +
              actName + 
              "</p>"+
              "</div>"
            );
          },
          
          color: "#424242",
          filter: {
            property: "y",
            operator: ">",
            value: 0,
          },
          showInLegend: true,
        },
      },
    ],
  };

  return (
    <>
      <Card className={classes.root}>
        <CardHeader
          title={title}
          className={classes.cardHeader}
          titleTypographyProps={{
            component: "h2",
            variant: "subtitle1",
            noWrap: true,
            className: classes.cardTitle,
          }}
        />
        <CardContent>
          <Box><b>{t("other.tlEmployeeName")} : {workerName}</b></Box>
        </CardContent>
        
        <CardContent className={classes.mainCard}>
          <Box className={classes.boxContent}>{children}</Box>
        </CardContent>
        <LoaderView loading={employeeTimeLineViewLoading}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
          ></Grid>
          {timeLineViewData ? (
            <>
              <div className={classes.timeIn + " " + classes.timeSet}>
                {t("other.inLbl")}:{inTS}
              </div>
              <div className={classes.timeOut + " " + classes.timeSet}>
              {t("other.outLbl")}:{outTS}
              </div>
              <div className={classes.chartDiv}>
                <div style={{ width: 1200 }}>
                  {/* <Charts data={{}} config={config} /> */}
                  <HighchartsReact
                  highcharts={Highcharts}
                  options={config}
                />
                </div>
              </div>
            </>
          ) : (
            // </ResponsiveContainer>
            <>
              <Box style={{ marginTop: "30px" }} className={classes.full}>
                <Alert severity="info">{t("other.errNoReportData3")}</Alert>
              </Box>
            </>
          )}
        </LoaderView>
      </Card>
    </>
  );
};

export default WareHouseTimeLineView;
